export function showHidePassword() {
	'use strict';

	const buttonsShowHidePass = document?.querySelectorAll('[data-show-hide-password]');

	if (buttonsShowHidePass.length > 0) {
		buttonsShowHidePass.forEach(el => {
			el.addEventListener('click', (e) => {
				const target = e.target;

				const targetParent = target.parentNode;

				targetParent.classList.toggle('view-password');

				const targetInput = targetParent.querySelector('input');

				if (targetInput.getAttribute('type') === 'password') {
					targetInput.setAttribute('type', 'text');
				} else {
					targetInput.setAttribute('type', 'password');
				}
			});
		});
	}
}